<template>
  <el-dialog
    v-dialogDrag
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :title="textMap[dialogStatus]"
    :visible.sync="dialogFormVisible"
    width="30%"
    top="2vh"
    @close="clearForm">
    <el-form :model="listForm" ref="listForm" :rules="validateRule" label-width="120px" size="small">
      <el-form-item label="代码集编号" prop="setId">
        <el-input :disabled="dialogStatus=='update'" v-model="listForm.setId" />
      </el-form-item>
      <el-form-item label="代码集名称" prop="setName">
        <el-input v-model="listForm.setName" />
      </el-form-item>
      <el-form-item label="英文名称" prop="setEnName">
        <el-input v-model="listForm.setEnName" />
      </el-form-item>
      <el-form-item label="状态" prop="setStatus">
        <el-select :disabled="tableItem" v-model="listForm.setStatus" placeholder="请选择">
          <el-option key="0" value="0" label="禁用"></el-option>
          <el-option key="1" value="1" label="启用"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否有层级" prop="setLayer">
        <el-select :disabled="tableItem" v-model="listForm.setLayer" placeholder="请选择">
          <el-option key="0" value="0" label="无层级"></el-option>
          <el-option key="1" value="1" label="有层级"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="air-modal-footer flex jend acenter">
      <el-button type="primary" :disabled="btnUnable" @click="handlerListForm()">保 存</el-button>
      <el-button @click="cancel()">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {addCodeItemSet,updateCodeSet} from "@/api/sys/code"
export default {
    name:'SysCodeSetDialog',
    props:{
        status:{
            type: Array,
            default:[]
        },
        layer:{
            type:Array,
            default: []
        },
        dialogStatus:{
            type: String,
            default: ""
        },
        dialogFormVisible: {
            type: Boolean
        },
        listForm:{
            type:Object,
            default: {}
        }
    },

    data() {
        return {
            btnUnable: false,

            textMap: {
                add: "新增参数",
                update: "编辑参数"
            },

            validateRule:{
                setName: [
                    { required: true, message: "代码集名称不能为空！", trigger: "blur"}
                ],
                // setEnName: [
                //     { required: true, message: "代码集英文名不能为空！", trigger: "blur"}
                // ],
                setStatus: [
                    { required: true, message: "状态不能为空！", trigger: "blur"}
                ],
                // setLayer: [
                //     { required: true, message: "层级不能为空！", trigger: "blur"}
                // ],
            }
        }
    },
    methods: {
        handlerListForm() {
            if (this.dialogStatus === "add") {
            this.addForm();
            } else if (this.dialogStatus === "update") {
            this.updateForm();
            }
        },
        addForm(){
            this.$refs.listForm.validate((valid) => {
                this.btnUnable=true
                if(valid){
                    addCodeItemSet(this.listForm).then((res)=>{
                        let rs=res.data
                        if (rs.code == 0){
                            this.btnUnable=false
                            this.$emit('data-refresh');
                            this.$message.success("新增成功！");
                            this.dialogFormVisible = false;
                        } else {
                            this.btnUnable=false
                            this.$message.error("新增失败！");
                        }
                    })
                }
            })
        },
        updateForm() {
            this.btnUnable=true
            this.$refs.listForm.validate((valid) => {
                if (valid){
                    updateCodeSet(this.listForm).then(res => {
                    if (res.data.code !== 2){
                        this.btnUnable=false
                        this.dialogFormVisible = false;
                        this.$emit('data-refresh');
                        this.$message.success("编辑成功！");
                    } else {
                        this.btnUnable=false
                        this.$message.error("编辑失败！");
                    }
                    })
                }else{
                    this.btnUnable=false
                }
            })
        },
        // 关闭后清空dialog
        clearForm: function(){
        this.$refs.listForm.resetFields()
        this.$refs.listForm.clearValidate()
        this.dialogFormVisible = false
        this.btnUnable=false
        this.$emit('update:dialogFormVisible',false)
        },
        cancel: function(){
            this.dialogFormVisible = false
            this.$emit('update:dialogFormVisible',false)
        }
    },
}
</script>
